import { Link, useLoaderData, useParams } from "react-router-dom";
import { LocalDateTime } from "@js-joda/core";
import { ReservationCard } from "./Controls/ReservationCard";
import { PageTitle } from "./Controls/PageTitle";
import { Col, Container, Row } from "react-bootstrap";
import { Reservation } from "./Data/ApiTypes";

export function UserReservationsPage() {
    const reservations = useLoaderData() as Reservation[];

    return <Container fluid>
        <Row>
            <Col>
                <div className="d-grid align-items-center">
                    <PageTitle className="grid-col-1">
                        Reservations
                    </PageTitle>
                   
                </div>
                {reservations.length === 0 && <div>You have no reservations</div>}
                {reservations.map( r => <ReservationCard key={r.reservationId} reservation={r} /> )}
            </Col>
        </Row>
    </Container>;
}